import { useEffect, useState } from "react"
import Base from "../../Base/views/Base"
import Box from '@mui/material/Box';
import { Button, Card, CardActionArea, CardActions, CardContent, CardMedia, Grid, IconButton, Link, TextField, Typography } from "@mui/material";
import food from "../../assets/food.jpg";
import DeleteIcon from '@mui/icons-material/Delete';
import Popup from "../../components/Popup";
import Swal from "sweetalert2";
import axiosInstance from "../../../axiosInstance";

const FoodLandingPage = () => {

    const [hotelID,] = useState(localStorage.getItem("billing_app_hotel"))
    const [data, setData] = useState([]);
    const [open, setOpen] = useState(false);
    const initialValues = {
        name: "",
        price: "",
        description: "",
        hotel: ""
    }
    const [inputData, setInputData] = useState(initialValues)
    const [errors, setErrors] = useState(initialValues)

    useEffect(() => {
        getData()
        //eslint-disable-next-line
    }, [])

    const getData = () => {
        axiosInstance(`/api/food/?hotel=${hotelID}`, {
            method: "GET"
        }).then(res => {
            setData(res.data)
        }).catch(err => {
            console.log(err)
        })
    }

    const validate = (fieldValues) => {
        let temp = { ...errors };
        if ("name" in fieldValues) {
            temp.name =
                fieldValues.name === "" || null ? "Name is required" : "";
        }
        if ("price" in fieldValues) {
            temp.price =
                fieldValues.price === "" || null ? "Price is required" : "";
        }

        setErrors({ ...temp });
        return Object.values(temp).every((x) => x === "");
    };

    const handleChange = (e) => {
        setInputData({ ...inputData, [e.target.name]: e.target.value })
    }

    const handleClose = () => {
        setOpen(false);
        setInputData(initialValues);
    }

    const handleSubmit = () => {
        let api = inputData?.id ? `/api/food/${inputData.id}/` : `/api/food/`;
        let method = inputData?.id ? "PUT" : "POST";
        if (validate(inputData)) {
            axiosInstance(api, {
                method: method,
                data: {
                    name: inputData.name,
                    price: inputData.price,
                    description: inputData.description,
                    hotel: hotelID
                }
            }).then(res => {
                getData();
                setInputData(initialValues);
                setErrors(initialValues);
                setOpen(false);
            }).catch(err => {
                console.log(err)
            })
        }
    }

    const handleClick = (res) => {
        setOpen(true);
        setInputData(res);
    }

    const handleDelete = (e, id) => {
        e?.stopPropagation();
        Swal.fire({
            title: "Are you sure?",
            text: "Are you sure want to delete this Food?",
            showDenyButton: false,
            showCancelButton: true,
            showConfirmButton: true,
            cancelButtonText: "Cancel",
            confirmButtonText: "Delete Food",
            icon: 'warning',
            reverseButtons: true,

        }).then((result) => {
            if (result.isConfirmed) {
                axiosInstance(`/api/food/${id}/`, {
                    method: "DELETE"
                }).then(res => {
                    getData();
                    Swal.fire({
                        icon: 'success',
                        title: 'Deleted!',
                        text: 'Food has been deleted successfully',
                        showConfirmButton: true,
                        timer: 1500
                    })
                }).catch(err => {
                    console.log(err)
                })
            }
        })


    }
    return (
        <Base>
            <Popup
                open={open}
                handleClose={handleClose}
                title={"Food"}
                handleSubmit={() => handleSubmit()}
                maxWidth="sm"
            >
                <Box sx={{ mt: 2, mb: 2 }}>
                    <TextField
                        label="Food Name"
                        fullWidth
                        required
                        name="name"
                        onChange={handleChange}
                        autoFocus={true}
                        value={inputData?.name || ""}
                        size="small"
                        sx={{ mt: 2, width: "100%" }}
                        {...(errors.name && {
                            error: true,
                            helperText: errors.name,
                        })}
                    />
                    <TextField
                        label="Price"
                        type="number"
                        fullWidth
                        required
                        name="price"
                        onChange={handleChange}
                        autoFocus={true}
                        value={inputData?.price || ""}
                        size="small"
                        sx={{ mt: 2, width: "100%" }}
                        {...(errors.price && {
                            error: true,
                            helperText: errors.price,
                        })}
                    />
                    <TextField
                        label="Description"
                        type="text"
                        fullWidth
                        name="description"
                        onChange={handleChange}
                        autoFocus={true}
                        value={inputData?.description || ""}
                        size="small"
                        rows={5}
                        multiline
                        sx={{ mt: 2, width: "100%" }}
                    />
                </Box>
            </Popup>

            <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", mb: 2 }}>
                <Button
                    variant="contained"
                    onClick={() => setOpen(true)}
                    size="small"
                    sx={{
                        borderRadius: 1.5,
                        px: 2,
                        py: 0.75,
                        textTransform: 'none',
                        fontWeight: 600,
                        boxShadow: '0 2px 8px rgba(139, 68, 255, 0.3)',
                        '&:hover': {
                            boxShadow: '0 4px 12px rgba(139, 68, 255, 0.4)',
                            transform: 'translateY(-1px)',
                        },
                        transition: 'all 0.3s ease',
                    }}
                >
                    Add Food
                </Button>
            </Box>
            <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                    {data?.map((res) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={res.id}>
                            <Card
                                onClick={() => handleClick(res)}
                                sx={{
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    cursor: 'pointer',
                                    overflow: 'hidden',
                                    '&:hover': {
                                        transform: 'translateY(-8px)',
                                        boxShadow: '0 12px 32px rgba(139, 68, 255, 0.15)',
                                    },
                                }}
                            >
                                <CardActionArea sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
                                    <CardMedia
                                        component="img"
                                        height="140"
                                        image={res?.image ? res?.image : food}
                                        alt={res?.name}
                                        sx={{
                                            objectFit: 'cover',
                                            transition: 'transform 0.3s ease',
                                            '&:hover': {
                                                transform: 'scale(1.05)',
                                            }
                                        }}
                                    />
                                    <CardContent sx={{ flexGrow: 1, pb: 0.5, pt: 1.5, px: 1.5 }}>
                                        <Typography
                                            gutterBottom
                                            variant="subtitle1"
                                            component="div"
                                            sx={{
                                                fontWeight: 600,
                                                mb: 0.5,
                                                color: 'text.primary',
                                                fontSize: '0.95rem',
                                            }}
                                        >
                                            {res?.name}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: 'text.secondary',
                                                mb: 1,
                                                fontSize: '0.8rem',
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                            }}
                                        >
                                            {res?.description || 'No description'}
                                        </Typography>
                                    </CardContent>
                                </CardActionArea>
                                <CardActions sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    px: 1.5,
                                    pb: 1.5,
                                    pt: 0,
                                }}>
                                    <Typography
                                        variant="subtitle1"
                                        sx={{
                                            color: 'primary.main',
                                            fontWeight: 700,
                                            fontSize: '1rem',
                                        }}
                                    >
                                        ₹{res?.price}
                                    </Typography>
                                    <IconButton
                                        size="small"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleDelete(e, res?.id);
                                        }}
                                        aria-label="delete"
                                        sx={{
                                            transition: 'all 0.2s ease',
                                            '&:hover': {
                                                transform: 'scale(1.1)',
                                                backgroundColor: 'error.lighter',
                                            }
                                        }}
                                    >
                                        <DeleteIcon fontSize="small" color="error" />
                                    </IconButton>
                                </CardActions>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
            {data?.length === 0 && (
                <Box
                    sx={{
                        mt: 8,
                        textAlign: "center",
                        py: 8,
                    }}
                >
                    <Typography
                        variant="h5"
                        sx={{
                            color: 'text.secondary',
                            mb: 2,
                            fontWeight: 500,
                        }}
                    >
                        No Menus yet
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: 'text.secondary',
                            mb: 4,
                        }}
                    >
                        Create your first menu item to get started
                    </Typography>
                    <Button
                        variant="contained"
                        onClick={() => setOpen(true)}
                        sx={{
                            borderRadius: 2,
                            px: 4,
                            py: 1.5,
                            textTransform: 'none',
                            fontWeight: 600,
                        }}
                    >
                        Create New Menu
                    </Button>
                </Box>
            )}
        </Base>
    )
}

export default FoodLandingPage